@file:OptIn(InternalResourceApi::class)

package com.nonopn.skywatcher.common.app.res

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.nonopn.skywatcher.common.app.res/"

@delegate:ResourceContentHash(1_111_052_896)
internal val Res.string.generate_keraunic_report: StringResource by lazy {
      StringResource("string:generate_keraunic_report", "generate_keraunic_report", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22923, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23019, 60),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 22503, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21399, 52),
      ))
    }

@delegate:ResourceContentHash(-754_901_223)
internal val Res.string.intensities_title: StringResource by lazy {
      StringResource("string:intensities_title", "intensities_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 22980, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23080, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 22564, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21452, 41),
      ))
    }

@delegate:ResourceContentHash(1_638_274_434)
internal val Res.string.intensity_avg_negative: StringResource by lazy {
      StringResource("string:intensity_avg_negative", "intensity_avg_negative", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23022, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23122, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 22606, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21494, 42),
      ))
    }

@delegate:ResourceContentHash(-1_886_215_099)
internal val Res.string.intensity_avg_positive: StringResource by lazy {
      StringResource("string:intensity_avg_positive", "intensity_avg_positive", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23065, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23165, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 22653, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21537, 42),
      ))
    }

@delegate:ResourceContentHash(-2_022_937_408)
internal val Res.string.intensity_cg_negative_arrow: StringResource by lazy {
      StringResource("string:intensity_cg_negative_arrow", "intensity_cg_negative_arrow", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23108, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23208, 47),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 22696, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21580, 47),
      ))
    }

@delegate:ResourceContentHash(-810_718_016)
internal val Res.string.intensity_cg_positive_arrow: StringResource by lazy {
      StringResource("string:intensity_cg_positive_arrow", "intensity_cg_positive_arrow", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23156, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23256, 47),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 22744, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21628, 47),
      ))
    }

@delegate:ResourceContentHash(704_369_720)
internal val Res.string.intensity_distribution_title: StringResource by lazy {
      StringResource("string:intensity_distribution_title", "intensity_distribution_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23204, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23304, 68),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 22792, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21676, 68),
      ))
    }

@delegate:ResourceContentHash(-1_747_209_106)
internal val Res.string.intensity_max_negative: StringResource by lazy {
      StringResource("string:intensity_max_negative", "intensity_max_negative", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23281, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23373, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 22869, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21745, 42),
      ))
    }

@delegate:ResourceContentHash(1_273_162_868)
internal val Res.string.intensity_max_positive: StringResource by lazy {
      StringResource("string:intensity_max_positive", "intensity_max_positive", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23328, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23416, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 22916, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21788, 42),
      ))
    }

@delegate:ResourceContentHash(890_364_316)
internal val Res.string.invalid: StringResource by lazy {
      StringResource("string:invalid", "invalid", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23371, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23459, 27),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 22959, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21831, 27),
      ))
    }

@delegate:ResourceContentHash(74_871_992)
internal val Res.string.keraunic_effect_fire_desc: StringResource by lazy {
      StringResource("string:keraunic_effect_fire_desc", "keraunic_effect_fire_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23399, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23487, 113),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 22987, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21859, 105),
      ))
    }

@delegate:ResourceContentHash(-300_204_532)
internal val Res.string.keraunic_effect_lemp_desc: StringResource by lazy {
      StringResource("string:keraunic_effect_lemp_desc", "keraunic_effect_lemp_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23525, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23601, 133),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 23105, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21965, 113),
      ))
    }

@delegate:ResourceContentHash(-1_631_548_599)
internal val Res.string.keraunic_effect_mechanical_desc: StringResource by lazy {
      StringResource("string:keraunic_effect_mechanical_desc", "keraunic_effect_mechanical_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23647, 115),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23735, 107),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 23231, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22079, 99),
      ))
    }

@delegate:ResourceContentHash(-849_886_316)
internal val Res.string.keraunic_effect_scada_desc: StringResource by lazy {
      StringResource("string:keraunic_effect_scada_desc", "keraunic_effect_scada_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23763, 134),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23843, 122),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 23339, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22179, 106),
      ))
    }

@delegate:ResourceContentHash(-51_170_704)
internal val Res.string.keraunic_export_pdf: StringResource by lazy {
      StringResource("string:keraunic_export_pdf", "keraunic_export_pdf", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23898, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 23966, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 23466, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22286, 51),
      ))
    }

@delegate:ResourceContentHash(239_108_434)
internal val Res.string.keraunic_intensity_avg: StringResource by lazy {
      StringResource("string:keraunic_intensity_avg", "keraunic_intensity_avg", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 23954, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24022, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 23522, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22338, 50),
      ))
    }

@delegate:ResourceContentHash(1_565_730_656)
internal val Res.string.keraunic_intensity_max: StringResource by lazy {
      StringResource("string:keraunic_intensity_max", "keraunic_intensity_max", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24009, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24073, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 23577, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22389, 50),
      ))
    }

@delegate:ResourceContentHash(-2_063_572_972)
internal val Res.string.keraunic_interpret_density: StringResource by lazy {
      StringResource("string:keraunic_interpret_density", "keraunic_interpret_density", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24064, 462),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24124, 514),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 23632, 446),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22440, 446),
      ))
    }

@delegate:ResourceContentHash(-1_860_563_358)
internal val Res.string.keraunic_interpret_hourly: StringResource by lazy {
      StringResource("string:keraunic_interpret_hourly", "keraunic_interpret_hourly", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24527, 357),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24639, 345),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 24079, 341),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22887, 317),
      ))
    }

@delegate:ResourceContentHash(-2_124_290_527)
internal val Res.string.keraunic_interpret_monthly: StringResource by lazy {
      StringResource("string:keraunic_interpret_monthly", "keraunic_interpret_monthly", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 24885, 458),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 24985, 438),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 24421, 454),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23205, 422),
      ))
    }

@delegate:ResourceContentHash(201_151_406)
internal val Res.string.keraunic_methodology_body: StringResource by lazy {
      StringResource("string:keraunic_methodology_body", "keraunic_methodology_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25344, 457),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25424, 473),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 24876, 497),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 23628, 413),
      ))
    }

@delegate:ResourceContentHash(507_212_011)
internal val Res.string.keraunic_methodology_title: StringResource by lazy {
      StringResource("string:keraunic_methodology_title", "keraunic_methodology_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25802, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25898, 74),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 25374, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24042, 70),
      ))
    }

@delegate:ResourceContentHash(-1_858_448_502)
internal val Res.string.keraunic_month_apr: StringResource by lazy {
      StringResource("string:keraunic_month_apr", "keraunic_month_apr", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25873, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 25973, 30),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 25445, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24113, 30),
      ))
    }

@delegate:ResourceContentHash(-1_677_372_508)
internal val Res.string.keraunic_month_aug: StringResource by lazy {
      StringResource("string:keraunic_month_aug", "keraunic_month_aug", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25904, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26004, 34),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 25476, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24144, 30),
      ))
    }

@delegate:ResourceContentHash(-950_898_197)
internal val Res.string.keraunic_month_dec: StringResource by lazy {
      StringResource("string:keraunic_month_dec", "keraunic_month_dec", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25935, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26039, 34),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 25507, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24175, 30),
      ))
    }

@delegate:ResourceContentHash(454_182_206)
internal val Res.string.keraunic_month_feb: StringResource by lazy {
      StringResource("string:keraunic_month_feb", "keraunic_month_feb", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25966, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26074, 34),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 25538, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24206, 30),
      ))
    }

@delegate:ResourceContentHash(-906_553_981)
internal val Res.string.keraunic_month_jan: StringResource by lazy {
      StringResource("string:keraunic_month_jan", "keraunic_month_jan", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 25997, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26109, 30),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 25569, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24237, 30),
      ))
    }

@delegate:ResourceContentHash(1_701_604_508)
internal val Res.string.keraunic_month_jul: StringResource by lazy {
      StringResource("string:keraunic_month_jul", "keraunic_month_jul", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26028, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26140, 30),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 25600, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24268, 30),
      ))
    }

@delegate:ResourceContentHash(1_701_666_076)
internal val Res.string.keraunic_month_jun: StringResource by lazy {
      StringResource("string:keraunic_month_jun", "keraunic_month_jun", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26059, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26171, 30),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 25631, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24299, 30),
      ))
    }

@delegate:ResourceContentHash(1_923_187_740)
internal val Res.string.keraunic_month_mar: StringResource by lazy {
      StringResource("string:keraunic_month_mar", "keraunic_month_mar", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26090, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26202, 30),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 25662, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24330, 30),
      ))
    }

@delegate:ResourceContentHash(1_921_152_956)
internal val Res.string.keraunic_month_may: StringResource by lazy {
      StringResource("string:keraunic_month_may", "keraunic_month_may", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26121, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26233, 30),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 25693, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24361, 30),
      ))
    }

@delegate:ResourceContentHash(-1_735_535_844)
internal val Res.string.keraunic_month_nov: StringResource by lazy {
      StringResource("string:keraunic_month_nov", "keraunic_month_nov", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26152, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26264, 30),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 25724, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24392, 30),
      ))
    }

@delegate:ResourceContentHash(834_025_731)
internal val Res.string.keraunic_month_oct: StringResource by lazy {
      StringResource("string:keraunic_month_oct", "keraunic_month_oct", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26183, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26295, 30),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 25755, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24423, 30),
      ))
    }

@delegate:ResourceContentHash(1_760_892_291)
internal val Res.string.keraunic_month_sep: StringResource by lazy {
      StringResource("string:keraunic_month_sep", "keraunic_month_sep", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26214, 30),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26326, 30),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 25786, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24454, 30),
      ))
    }

@delegate:ResourceContentHash(-578_854_694)
internal val Res.string.keraunic_project_label: StringResource by lazy {
      StringResource("string:keraunic_project_label", "keraunic_project_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26245, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26357, 38),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 25817, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24485, 42),
      ))
    }

@delegate:ResourceContentHash(-914_107_130)
internal val Res.string.keraunic_report_title: StringResource by lazy {
      StringResource("string:keraunic_report_title", "keraunic_report_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26352, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26456, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 25924, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24580, 49),
      ))
    }

@delegate:ResourceContentHash(-1_368_912_089)
internal val Res.string.keraunic_report_title_label: StringResource by lazy {
      StringResource("string:keraunic_report_title_label", "keraunic_report_title_label", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26288, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26396, 59),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 25860, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24528, 51),
      ))
    }

@delegate:ResourceContentHash(-104_876_558)
internal val Res.string.keraunic_retry: StringResource by lazy {
      StringResource("string:keraunic_retry", "keraunic_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26406, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26514, 38),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 25982, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24630, 30),
      ))
    }

@delegate:ResourceContentHash(-441_497_394)
internal val Res.string.keraunic_risk_fire: StringResource by lazy {
      StringResource("string:keraunic_risk_fire", "keraunic_risk_fire", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26445, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26553, 38),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 26029, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24661, 34),
      ))
    }

@delegate:ResourceContentHash(1_383_743_928)
internal val Res.string.keraunic_risk_lemp: StringResource by lazy {
      StringResource("string:keraunic_risk_lemp", "keraunic_risk_lemp", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26484, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26592, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 26068, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24696, 42),
      ))
    }

@delegate:ResourceContentHash(860_051_682)
internal val Res.string.keraunic_risk_mechanical: StringResource by lazy {
      StringResource("string:keraunic_risk_mechanical", "keraunic_risk_mechanical", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26535, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26639, 64),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 26119, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24739, 64),
      ))
    }

@delegate:ResourceContentHash(2_013_133_922)
internal val Res.string.keraunic_risk_scada: StringResource by lazy {
      StringResource("string:keraunic_risk_scada", "keraunic_risk_scada", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26600, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26704, 59),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 26184, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24804, 59),
      ))
    }

@delegate:ResourceContentHash(1_908_857_954)
internal val Res.string.keraunic_screen_conclusion_body: StringResource by lazy {
      StringResource("string:keraunic_screen_conclusion_body", "keraunic_screen_conclusion_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 26664, 711),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 26764, 779),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 26248, 755),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 24864, 631),
      ))
    }

@delegate:ResourceContentHash(144_675_537)
internal val Res.string.keraunic_screen_danger_direct: StringResource by lazy {
      StringResource("string:keraunic_screen_danger_direct", "keraunic_screen_danger_direct", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 27376, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27544, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 27004, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25496, 57),
      ))
    }

@delegate:ResourceContentHash(-516_057_706)
internal val Res.string.keraunic_screen_danger_indirect: StringResource by lazy {
      StringResource("string:keraunic_screen_danger_indirect", "keraunic_screen_danger_indirect", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 27434, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27602, 59),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 27062, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25554, 59),
      ))
    }

@delegate:ResourceContentHash(858_671_004)
internal val Res.string.keraunic_screen_direct_zone_subtitle: StringResource by lazy {
      StringResource("string:keraunic_screen_direct_zone_subtitle", "keraunic_screen_direct_zone_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 27498, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27662, 92),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 27122, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25614, 88),
      ))
    }

@delegate:ResourceContentHash(-532_400_680)
internal val Res.string.keraunic_screen_effects_context: StringResource by lazy {
      StringResource("string:keraunic_screen_effects_context", "keraunic_screen_effects_context", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 27595, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27755, 87),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 27215, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25703, 87),
      ))
    }

@delegate:ResourceContentHash(784_490_586)
internal val Res.string.keraunic_screen_free_observations: StringResource by lazy {
      StringResource("string:keraunic_screen_free_observations", "keraunic_screen_free_observations", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 27683, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27843, 73),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 27303, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25791, 73),
      ))
    }

@delegate:ResourceContentHash(-1_306_090_733)
internal val Res.string.keraunic_screen_hourly_distribution: StringResource by lazy {
      StringResource("string:keraunic_screen_hourly_distribution", "keraunic_screen_hourly_distribution", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 27761, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 27917, 83),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 27381, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25865, 83),
      ))
    }

@delegate:ResourceContentHash(1_890_145_665)
internal val Res.string.keraunic_screen_impacts_recorded: StringResource by lazy {
      StringResource("string:keraunic_screen_impacts_recorded", "keraunic_screen_impacts_recorded", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 27849, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28001, 76),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 27469, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 25949, 68),
      ))
    }

@delegate:ResourceContentHash(-1_877_701_784)
internal val Res.string.keraunic_screen_indirect_zone_subtitle: StringResource by lazy {
      StringResource("string:keraunic_screen_indirect_zone_subtitle", "keraunic_screen_indirect_zone_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 27926, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28078, 98),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 27542, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26018, 94),
      ))
    }

@delegate:ResourceContentHash(-786_011_234)
internal val Res.string.keraunic_screen_key_metrics: StringResource by lazy {
      StringResource("string:keraunic_screen_key_metrics", "keraunic_screen_key_metrics", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28029, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28177, 71),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 27637, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26113, 63),
      ))
    }

@delegate:ResourceContentHash(1_520_826_557)
internal val Res.string.keraunic_screen_loading_error: StringResource by lazy {
      StringResource("string:keraunic_screen_loading_error", "keraunic_screen_loading_error", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28244, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28396, 73),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 27872, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26296, 65),
      ))
    }

@delegate:ResourceContentHash(582_762_701)
internal val Res.string.keraunic_screen_loading_error_body: StringResource by lazy {
      StringResource("string:keraunic_screen_loading_error_body", "keraunic_screen_loading_error_body", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28097, 146),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28249, 146),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 27717, 154),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26177, 118),
      ))
    }

@delegate:ResourceContentHash(-355_103_199)
internal val Res.string.keraunic_screen_map_impacts: StringResource by lazy {
      StringResource("string:keraunic_screen_map_impacts", "keraunic_screen_map_impacts", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28310, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28470, 59),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 27946, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26362, 51),
      ))
    }

@delegate:ResourceContentHash(-1_443_719_067)
internal val Res.string.keraunic_screen_monthly_activity: StringResource by lazy {
      StringResource("string:keraunic_screen_monthly_activity", "keraunic_screen_monthly_activity", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28370, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28530, 72),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28006, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26414, 68),
      ))
    }

@delegate:ResourceContentHash(1_206_924_876)
internal val Res.string.keraunic_screen_sensor_count_short: StringResource by lazy {
      StringResource("string:keraunic_screen_sensor_count_short", "keraunic_screen_sensor_count_short", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28443, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28603, 54),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28075, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26483, 58),
      ))
    }

@delegate:ResourceContentHash(2_062_796_595)
internal val Res.string.keraunic_screen_stat_average: StringResource by lazy {
      StringResource("string:keraunic_screen_stat_average", "keraunic_screen_stat_average", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28502, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28658, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28134, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26542, 48),
      ))
    }

@delegate:ResourceContentHash(-1_901_414_208)
internal val Res.string.keraunic_screen_stat_max: StringResource by lazy {
      StringResource("string:keraunic_screen_stat_max", "keraunic_screen_stat_max", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28555, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28707, 44),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28187, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26591, 44),
      ))
    }

@delegate:ResourceContentHash(-280_693_325)
internal val Res.string.keraunic_screen_stat_median: StringResource by lazy {
      StringResource("string:keraunic_screen_stat_median", "keraunic_screen_stat_median", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28604, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28752, 51),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28236, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26636, 51),
      ))
    }

@delegate:ResourceContentHash(1_947_424_667)
internal val Res.string.keraunic_screen_top_impacts: StringResource by lazy {
      StringResource("string:keraunic_screen_top_impacts", "keraunic_screen_top_impacts", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28656, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28804, 71),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28288, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26688, 63),
      ))
    }

@delegate:ResourceContentHash(-1_189_400_642)
internal val Res.string.keraunic_screen_zone_title: StringResource by lazy {
      StringResource("string:keraunic_screen_zone_title", "keraunic_screen_zone_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28724, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28876, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28356, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26752, 50),
      ))
    }

@delegate:ResourceContentHash(225_573_855)
internal val Res.string.keraunic_total_impacts: StringResource by lazy {
      StringResource("string:keraunic_total_impacts", "keraunic_total_impacts", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28775, 50),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28927, 50),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28407, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26803, 50),
      ))
    }

@delegate:ResourceContentHash(610_779_622)
internal val Res.string.keraunic_unit_impacts: StringResource by lazy {
      StringResource("string:keraunic_unit_impacts", "keraunic_unit_impacts", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28826, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 28978, 41),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28458, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26854, 41),
      ))
    }

@delegate:ResourceContentHash(63_195_789)
internal val Res.string.keraunic_zone_summary: StringResource by lazy {
      StringResource("string:keraunic_zone_summary", "keraunic_zone_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28868, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29020, 73),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28500, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26896, 69),
      ))
    }

@delegate:ResourceContentHash(-1_563_183_638)
internal val Res.string.label_conclusion: StringResource by lazy {
      StringResource("string:label_conclusion", "label_conclusion", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28938, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29094, 40),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28570, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 26966, 40),
      ))
    }

@delegate:ResourceContentHash(-8_708_437)
internal val Res.string.label_interpretation: StringResource by lazy {
      StringResource("string:label_interpretation", "label_interpretation", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 28979, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29135, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28611, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27007, 48),
      ))
    }

@delegate:ResourceContentHash(1_894_526_784)
internal val Res.string.label_latitude: StringResource by lazy {
      StringResource("string:label_latitude", "label_latitude", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29028, 26),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29184, 26),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28660, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27056, 26),
      ))
    }

@delegate:ResourceContentHash(1_884_244_928)
internal val Res.string.label_longitude: StringResource by lazy {
      StringResource("string:label_longitude", "label_longitude", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29055, 27),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29211, 27),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28687, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27083, 27),
      ))
    }

@delegate:ResourceContentHash(1_220_823_606)
internal val Res.string.label_observations: StringResource by lazy {
      StringResource("string:label_observations", "label_observations", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29083, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29239, 42),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28715, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27111, 42),
      ))
    }

@delegate:ResourceContentHash(-578_854_694)
internal val Res.string.label_project: StringResource by lazy {
      StringResource("string:label_project", "label_project", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29130, 33),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29282, 29),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28762, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27154, 33),
      ))
    }

@delegate:ResourceContentHash(452_928_724)
internal val Res.string.map_enter_address: StringResource by lazy {
      StringResource("string:map_enter_address", "map_enter_address", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29164, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29312, 49),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28796, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27188, 45),
      ))
    }

@delegate:ResourceContentHash(548_374_915)
internal val Res.string.map_fullscreen_close: StringResource by lazy {
      StringResource("string:map_fullscreen_close", "map_fullscreen_close", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29218, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29362, 36),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28850, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27234, 36),
      ))
    }

@delegate:ResourceContentHash(-459_764_031)
internal val Res.string.map_fullscreen_open: StringResource by lazy {
      StringResource("string:map_fullscreen_open", "map_fullscreen_open", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29255, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29399, 43),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28887, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27271, 43),
      ))
    }

@delegate:ResourceContentHash(944_681_815)
internal val Res.string.map_popup_created: StringResource by lazy {
      StringResource("string:map_popup_created", "map_popup_created", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29307, 37),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29443, 37),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28935, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27315, 41),
      ))
    }

@delegate:ResourceContentHash(2_010_401_080)
internal val Res.string.map_popup_doc_keraunic: StringResource by lazy {
      StringResource("string:map_popup_doc_keraunic", "map_popup_doc_keraunic", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29345, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29481, 58),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 28973, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27357, 50),
      ))
    }

@delegate:ResourceContentHash(-2_075_435_954)
internal val Res.string.map_popup_doc_lightning: StringResource by lazy {
      StringResource("string:map_popup_doc_lightning", "map_popup_doc_lightning", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29400, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29540, 67),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29032, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27408, 71),
      ))
    }

@delegate:ResourceContentHash(795_846_842)
internal val Res.string.map_popup_doc_nsg: StringResource by lazy {
      StringResource("string:map_popup_doc_nsg", "map_popup_doc_nsg", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29472, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29608, 45),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29104, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27480, 45),
      ))
    }

@delegate:ResourceContentHash(-2_004_320_288)
internal val Res.string.map_popup_documents: StringResource by lazy {
      StringResource("string:map_popup_documents", "map_popup_documents", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29518, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29654, 39),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29150, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27526, 39),
      ))
    }

@delegate:ResourceContentHash(9_744_670)
internal val Res.string.map_popup_filter: StringResource by lazy {
      StringResource("string:map_popup_filter", "map_popup_filter", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29562, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29694, 48),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29194, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27566, 48),
      ))
    }

@delegate:ResourceContentHash(1_369_229_221)
internal val Res.string.map_popup_impacts_30_days: StringResource by lazy {
      StringResource("string:map_popup_impacts_30_days", "map_popup_impacts_30_days", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29611, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29743, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29243, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27615, 49),
      ))
    }

@delegate:ResourceContentHash(-547_776_344)
internal val Res.string.map_popup_impacts_7_days: StringResource by lazy {
      StringResource("string:map_popup_impacts_7_days", "map_popup_impacts_7_days", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29669, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29801, 56),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29301, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27665, 48),
      ))
    }

@delegate:ResourceContentHash(1_523_890_100)
internal val Res.string.map_popup_impacts_today: StringResource by lazy {
      StringResource("string:map_popup_impacts_today", "map_popup_impacts_today", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29726, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29858, 59),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29354, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27714, 51),
      ))
    }

@delegate:ResourceContentHash(1_096_921_587)
internal val Res.string.map_popup_last_document: StringResource by lazy {
      StringResource("string:map_popup_last_document", "map_popup_last_document", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29774, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29918, 55),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29406, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27766, 51),
      ))
    }

@delegate:ResourceContentHash(1_549_274_903)
internal val Res.string.map_popup_no_document: StringResource by lazy {
      StringResource("string:map_popup_no_document", "map_popup_no_document", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29830, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 29974, 37),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29462, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27818, 37),
      ))
    }

@delegate:ResourceContentHash(-1_286_165_683)
internal val Res.string.map_popup_probe_row: StringResource by lazy {
      StringResource("string:map_popup_probe_row", "map_popup_probe_row", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29872, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30012, 35),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29500, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27856, 35),
      ))
    }

@delegate:ResourceContentHash(-1_286_165_683)
internal val Res.string.map_popup_probe_type: StringResource by lazy {
      StringResource("string:map_popup_probe_type", "map_popup_probe_type", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29908, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30048, 36),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29536, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27892, 36),
      ))
    }

@delegate:ResourceContentHash(-608_142_859)
internal val Res.string.map_popup_see_more: StringResource by lazy {
      StringResource("string:map_popup_see_more", "map_popup_see_more", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29945, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30085, 34),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29573, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27929, 38),
      ))
    }

@delegate:ResourceContentHash(-1_045_977_108)
internal val Res.string.map_popup_site_type: StringResource by lazy {
      StringResource("string:map_popup_site_type", "map_popup_site_type", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 29984, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30120, 51),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29612, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 27968, 51),
      ))
    }

@delegate:ResourceContentHash(404_403_520)
internal val Res.string.map_popup_sites_covered: StringResource by lazy {
      StringResource("string:map_popup_sites_covered", "map_popup_sites_covered", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30036, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30172, 63),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29664, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28020, 63),
      ))
    }

@delegate:ResourceContentHash(-395_144_917)
internal val Res.string.map_zoom_in: StringResource by lazy {
      StringResource("string:map_zoom_in", "map_zoom_in", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30104, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30236, 35),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29728, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28084, 31),
      ))
    }

@delegate:ResourceContentHash(403_256_931)
internal val Res.string.map_zoom_out: StringResource by lazy {
      StringResource("string:map_zoom_out", "map_zoom_out", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30136, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30272, 40),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29760, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28116, 32),
      ))
    }

@delegate:ResourceContentHash(1_249_650_361)
internal val Res.string.menu_admin_estimate: StringResource by lazy {
      StringResource("string:menu_admin_estimate", "menu_admin_estimate", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30274, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30450, 59),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29906, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28270, 51),
      ))
    }

@delegate:ResourceContentHash(5_455_595)
internal val Res.string.menu_admin_estimate_list: StringResource by lazy {
      StringResource("string:menu_admin_estimate_list", "menu_admin_estimate_list", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30165, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30313, 64),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29793, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28149, 60),
      ))
    }

@delegate:ResourceContentHash(161_944_922)
internal val Res.string.menu_admin_estimate_new: StringResource by lazy {
      StringResource("string:menu_admin_estimate_new", "menu_admin_estimate_new", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30222, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30378, 71),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29850, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28210, 59),
      ))
    }

@delegate:ResourceContentHash(-1_298_820_833)
internal val Res.string.menu_admin_mode_enter: StringResource by lazy {
      StringResource("string:menu_admin_mode_enter", "menu_admin_mode_enter", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30330, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30510, 69),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 29962, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28322, 69),
      ))
    }

@delegate:ResourceContentHash(-1_732_211_713)
internal val Res.string.menu_admin_mode_exit: StringResource by lazy {
      StringResource("string:menu_admin_mode_exit", "menu_admin_mode_exit", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30396, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30580, 68),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 30036, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28392, 52),
      ))
    }

@delegate:ResourceContentHash(-74_055_770)
internal val Res.string.menu_admin_mode_title: StringResource by lazy {
      StringResource("string:menu_admin_mode_title", "menu_admin_mode_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30457, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30649, 57),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 30101, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28445, 53),
      ))
    }

@delegate:ResourceContentHash(1_622_919_222)
internal val Res.string.menu_admin_promo_codes: StringResource by lazy {
      StringResource("string:menu_admin_promo_codes", "menu_admin_promo_codes", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30511, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30707, 46),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 30155, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28499, 46),
      ))
    }

@delegate:ResourceContentHash(-109_489_458)
internal val Res.string.menu_admin_strikeradar_certificates: StringResource by lazy {
      StringResource("string:menu_admin_strikeradar_certificates", "menu_admin_strikeradar_certificates", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 30574, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 30754, 91),
        ResourceItem(setOf(LanguageQualifier("pt"), ), "${MD}values-pt/strings.commonMain.cvr", 30214, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 28546, 91),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString3Resources(map: MutableMap<String, StringResource>) {
  map.put("generate_keraunic_report", Res.string.generate_keraunic_report)
  map.put("intensities_title", Res.string.intensities_title)
  map.put("intensity_avg_negative", Res.string.intensity_avg_negative)
  map.put("intensity_avg_positive", Res.string.intensity_avg_positive)
  map.put("intensity_cg_negative_arrow", Res.string.intensity_cg_negative_arrow)
  map.put("intensity_cg_positive_arrow", Res.string.intensity_cg_positive_arrow)
  map.put("intensity_distribution_title", Res.string.intensity_distribution_title)
  map.put("intensity_max_negative", Res.string.intensity_max_negative)
  map.put("intensity_max_positive", Res.string.intensity_max_positive)
  map.put("invalid", Res.string.invalid)
  map.put("keraunic_effect_fire_desc", Res.string.keraunic_effect_fire_desc)
  map.put("keraunic_effect_lemp_desc", Res.string.keraunic_effect_lemp_desc)
  map.put("keraunic_effect_mechanical_desc", Res.string.keraunic_effect_mechanical_desc)
  map.put("keraunic_effect_scada_desc", Res.string.keraunic_effect_scada_desc)
  map.put("keraunic_export_pdf", Res.string.keraunic_export_pdf)
  map.put("keraunic_intensity_avg", Res.string.keraunic_intensity_avg)
  map.put("keraunic_intensity_max", Res.string.keraunic_intensity_max)
  map.put("keraunic_interpret_density", Res.string.keraunic_interpret_density)
  map.put("keraunic_interpret_hourly", Res.string.keraunic_interpret_hourly)
  map.put("keraunic_interpret_monthly", Res.string.keraunic_interpret_monthly)
  map.put("keraunic_methodology_body", Res.string.keraunic_methodology_body)
  map.put("keraunic_methodology_title", Res.string.keraunic_methodology_title)
  map.put("keraunic_month_apr", Res.string.keraunic_month_apr)
  map.put("keraunic_month_aug", Res.string.keraunic_month_aug)
  map.put("keraunic_month_dec", Res.string.keraunic_month_dec)
  map.put("keraunic_month_feb", Res.string.keraunic_month_feb)
  map.put("keraunic_month_jan", Res.string.keraunic_month_jan)
  map.put("keraunic_month_jul", Res.string.keraunic_month_jul)
  map.put("keraunic_month_jun", Res.string.keraunic_month_jun)
  map.put("keraunic_month_mar", Res.string.keraunic_month_mar)
  map.put("keraunic_month_may", Res.string.keraunic_month_may)
  map.put("keraunic_month_nov", Res.string.keraunic_month_nov)
  map.put("keraunic_month_oct", Res.string.keraunic_month_oct)
  map.put("keraunic_month_sep", Res.string.keraunic_month_sep)
  map.put("keraunic_project_label", Res.string.keraunic_project_label)
  map.put("keraunic_report_title", Res.string.keraunic_report_title)
  map.put("keraunic_report_title_label", Res.string.keraunic_report_title_label)
  map.put("keraunic_retry", Res.string.keraunic_retry)
  map.put("keraunic_risk_fire", Res.string.keraunic_risk_fire)
  map.put("keraunic_risk_lemp", Res.string.keraunic_risk_lemp)
  map.put("keraunic_risk_mechanical", Res.string.keraunic_risk_mechanical)
  map.put("keraunic_risk_scada", Res.string.keraunic_risk_scada)
  map.put("keraunic_screen_conclusion_body", Res.string.keraunic_screen_conclusion_body)
  map.put("keraunic_screen_danger_direct", Res.string.keraunic_screen_danger_direct)
  map.put("keraunic_screen_danger_indirect", Res.string.keraunic_screen_danger_indirect)
  map.put("keraunic_screen_direct_zone_subtitle", Res.string.keraunic_screen_direct_zone_subtitle)
  map.put("keraunic_screen_effects_context", Res.string.keraunic_screen_effects_context)
  map.put("keraunic_screen_free_observations", Res.string.keraunic_screen_free_observations)
  map.put("keraunic_screen_hourly_distribution", Res.string.keraunic_screen_hourly_distribution)
  map.put("keraunic_screen_impacts_recorded", Res.string.keraunic_screen_impacts_recorded)
  map.put("keraunic_screen_indirect_zone_subtitle", Res.string.keraunic_screen_indirect_zone_subtitle)
  map.put("keraunic_screen_key_metrics", Res.string.keraunic_screen_key_metrics)
  map.put("keraunic_screen_loading_error", Res.string.keraunic_screen_loading_error)
  map.put("keraunic_screen_loading_error_body", Res.string.keraunic_screen_loading_error_body)
  map.put("keraunic_screen_map_impacts", Res.string.keraunic_screen_map_impacts)
  map.put("keraunic_screen_monthly_activity", Res.string.keraunic_screen_monthly_activity)
  map.put("keraunic_screen_sensor_count_short", Res.string.keraunic_screen_sensor_count_short)
  map.put("keraunic_screen_stat_average", Res.string.keraunic_screen_stat_average)
  map.put("keraunic_screen_stat_max", Res.string.keraunic_screen_stat_max)
  map.put("keraunic_screen_stat_median", Res.string.keraunic_screen_stat_median)
  map.put("keraunic_screen_top_impacts", Res.string.keraunic_screen_top_impacts)
  map.put("keraunic_screen_zone_title", Res.string.keraunic_screen_zone_title)
  map.put("keraunic_total_impacts", Res.string.keraunic_total_impacts)
  map.put("keraunic_unit_impacts", Res.string.keraunic_unit_impacts)
  map.put("keraunic_zone_summary", Res.string.keraunic_zone_summary)
  map.put("label_conclusion", Res.string.label_conclusion)
  map.put("label_interpretation", Res.string.label_interpretation)
  map.put("label_latitude", Res.string.label_latitude)
  map.put("label_longitude", Res.string.label_longitude)
  map.put("label_observations", Res.string.label_observations)
  map.put("label_project", Res.string.label_project)
  map.put("map_enter_address", Res.string.map_enter_address)
  map.put("map_fullscreen_close", Res.string.map_fullscreen_close)
  map.put("map_fullscreen_open", Res.string.map_fullscreen_open)
  map.put("map_popup_created", Res.string.map_popup_created)
  map.put("map_popup_doc_keraunic", Res.string.map_popup_doc_keraunic)
  map.put("map_popup_doc_lightning", Res.string.map_popup_doc_lightning)
  map.put("map_popup_doc_nsg", Res.string.map_popup_doc_nsg)
  map.put("map_popup_documents", Res.string.map_popup_documents)
  map.put("map_popup_filter", Res.string.map_popup_filter)
  map.put("map_popup_impacts_30_days", Res.string.map_popup_impacts_30_days)
  map.put("map_popup_impacts_7_days", Res.string.map_popup_impacts_7_days)
  map.put("map_popup_impacts_today", Res.string.map_popup_impacts_today)
  map.put("map_popup_last_document", Res.string.map_popup_last_document)
  map.put("map_popup_no_document", Res.string.map_popup_no_document)
  map.put("map_popup_probe_row", Res.string.map_popup_probe_row)
  map.put("map_popup_probe_type", Res.string.map_popup_probe_type)
  map.put("map_popup_see_more", Res.string.map_popup_see_more)
  map.put("map_popup_site_type", Res.string.map_popup_site_type)
  map.put("map_popup_sites_covered", Res.string.map_popup_sites_covered)
  map.put("map_zoom_in", Res.string.map_zoom_in)
  map.put("map_zoom_out", Res.string.map_zoom_out)
  map.put("menu_admin_estimate", Res.string.menu_admin_estimate)
  map.put("menu_admin_estimate_list", Res.string.menu_admin_estimate_list)
  map.put("menu_admin_estimate_new", Res.string.menu_admin_estimate_new)
  map.put("menu_admin_mode_enter", Res.string.menu_admin_mode_enter)
  map.put("menu_admin_mode_exit", Res.string.menu_admin_mode_exit)
  map.put("menu_admin_mode_title", Res.string.menu_admin_mode_title)
  map.put("menu_admin_promo_codes", Res.string.menu_admin_promo_codes)
  map.put("menu_admin_strikeradar_certificates", Res.string.menu_admin_strikeradar_certificates)
}
